var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"map"},[_c('GoogleMapLoader',{attrs:{"options":_vm.mapConfig,"apiKey":_vm.apiKey},scopedSlots:_vm._u([{key:"default",fn:function({ googleApi, map }){return [_c('GoogleMapRenderPath',{attrs:{"googleApi":googleApi,"map":map}})]}}])})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }